export default "__VITE_ASSET__BMY1BM7U__"